import React from 'react';
import Header from '../Header/Header';
import Projects from '../Projects/Projects'
import BlogSection from '../BlogSection/BlogSection'
import About from '../About/About'

const PortfolioMain = () => (
  <div>
    <Header />
    <About />
    <Projects />
    <BlogSection />
  </div>
)

export default PortfolioMain;


// WEBPACK FOOTER //
// ./src/PortfolioMain/PortfolioMain.js